import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { CommonService } from '../../services/common-service.service';
import { environment } from 'src/environments/environment';
import { DataStorageService } from '../../services/data-storage.service';
import { LoggedInUserInfo } from "src/app/shared/model/LoggedInUserInfo";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public elem: any;
  public dark: boolean = this.layout.config.settings.layout_version == 'dark-only' ? true : false;
  user = localStorage.getItem("user");
  userName: string;
  intranetURL: string;
  appMenuItems: any;
  userid?:any;
  EmpType?:any;
    isVisible: boolean = false;
  //sosApiEndPoint = environment.sosApiEndPoint;
  constructor(private api: DataStorageService,public layout: LayoutService,
    public navServices: NavService, private commonService: CommonService,
    @Inject(DOCUMENT) private document: any
  ) {

  }

  ngOnInit() {
    //debugger
    this.elem = document.documentElement;

    let user: LoggedInUserInfo = JSON.parse(localStorage.getItem('user') ?? '{}') as LoggedInUserInfo;
    this.user = user.UserName;
    this.userid = user.UserID;
    this.intranetURL = environment.intranetURL;
    this.EmpType =localStorage.getItem("EmpType");

    if(this.EmpType == 12)
    {
       this.isVisible = true;
    }
    else{
       this.isVisible = false;
    }
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu = false;
    this.navServices.levelMenu = false;
  }

  layoutToggle() {
    this.dark = !this.dark;
    this.layout.config.settings.layout_version = this.dark ? 'dark-only' : 'light';
  }

  searchToggle() {
    this.navServices.search = true;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  redirectHome() {
    //debugger
    this.clearSession(localStorage.getItem("UserID"));
    this.commonService.deleteAllCookies();
   // this.commonService.logoutRedirect();
   // window.location.href = " https://intranet.rspl.net.in/Default.aspx"
   window.location.href = environment.intranetURL;
    // window.location.href = "https://uatintranet.rspl.net.in/";
  }
  clearSession(UserID) {
    //debugger
    // this.api.postSoSData(this.sosApiEndPoint + "api/Authenticate/LogOut/" + UserID)
    //   .subscribe((data: any) => {
    //     console.log(data)
    //   });
  }
}
